import { Controller } from "@hotwired/stimulus"

/**
 * Stimulus controller for TypedDeleteConfirmationComponent.
 * Keeps the submit button disabled until the user types DELETE exactly.
 */
export default class extends Controller {
  static targets = ["input", "submit"]

  declare readonly inputTarget: HTMLInputElement
  declare readonly hasInputTarget: boolean
  declare readonly submitTarget: HTMLInputElement
  declare readonly hasSubmitTarget: boolean

  connect(): void {
    this.disable()
  }

  validate(): void {
    if (!this.hasInputTarget || !this.hasSubmitTarget) return
    const enabled = this.inputTarget.value === "DELETE"
    this.submitTarget.disabled = !enabled
  }

  private disable(): void {
    if (this.hasSubmitTarget) this.submitTarget.disabled = true
  }
}
